<template>
  <div class="navbar">
    <!-- 关闭菜单导航 -->
    <hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />

    <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" /> -->
    <span class="active-menu">{{ activeMenu }}</span>

    <div class="right-menu">
      <div v-if="notView" class="update-log-btn" @click="goYuQueLogs">
        新功能
        <span>1</span>
      </div>

      <mobile-box />
      <msg-tips v-if="msgTipsVisible" />
      <task-center />

      <!-- <template v-if="device!=='mobile'">
        <search id="header-search" class="right-menu-item" />

        <error-log class="errLog-container right-menu-item hover-effect" />

        <screenfull id="screenfull" class="right-menu-item hover-effect" />

        <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip>

      </template> -->
      <el-dropdown ref="document" class="avatar-container right-menu-item hover-effect">
        <div class="avatar-wrapper">
          <span class="ducuments"><i class="el-icon-document-copy" />帮助文档</span>
          <el-dropdown-menu>
            <el-dropdown-item>
              <span v-clipboard:copy="'gezq'" v-clipboard:success="onCopy" v-clipboard:error="onError">《业财系统视频教程》
                密码：gezq</span>
            </el-dropdown-item>
            <el-dropdown-item>
              <span v-clipboard:copy="'tzii'" v-clipboard:success="onCopy" v-clipboard:error="onError">《业财系统帮助文档》
                密码：tzii</span>
              <!-- v-clipboard:copy="message"
      v-clipboard:success="onCopy"
      v-clipboard:error="onError">Copy!</button>《节点业财系统帮助文档》 密码：tzii -->
            </el-dropdown-item>
            <el-dropdown-item>
              <span
                v-if="jurisdiction.indexOf('bdyCrm.viewBDCrm') != -1"
                v-clipboard:copy="'xsam'"
                v-clipboard:success="onCopy"
                v-clipboard:error="onError"
              >《标点CRM帮助文档》 密码：xsam</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </div>
      </el-dropdown>
      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <span v-if="bookInfo.subareaName" class="subareaName">{{
            bookInfo.subareaName
          }}</span>
          <span v-else class="no-subareaName">请先选择账本</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="(it, i) in book" :key="i" @click.native="setName(it.subareaName, it.id)"><span>{{
            it.subareaName }}</span></el-dropdown-item>
          <el-dropdown-item divided @click.native="manageBook()"><span
            style="display: block"
          >管理账本</span></el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown class="avatar-container right-menu-item hover-effect" trigger="click">
        <div class="avatar-wrapper">
          <!-- <div class="user-avatar"> -->
          <!-- <img :src="user.avatarViewAddress || require('./../../assets/imgs/default.jpg')"> -->
          <!-- </div> -->
          <span>{{ user.username }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item divided @click.native="toUser">
            <span style="display: block">个人中心</span>
          </el-dropdown-item>
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <network />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { sendLogout, switchSubarea } from './../../api/login.js'
import { getYuqueDoc } from '@/api/dashboard.js'
import MsgTips from './MsgTips'
import TaskCenter from './TaskCenter'
import MobileBox from './MobileBox.vue'
import Network from './Network.vue'

import Hamburger from '@/components/Hamburger'

export default {
  components: {
    Hamburger,
    MsgTips,
    TaskCenter,
    MobileBox,
    Network
  },
  data() {
    return {
      notView: false,
      logData: {}
    }
  },

  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'device',
      'bookInfo',
      'book',
      'user',
      'activeMenu',
      'jurisdiction',
      'isView'
    ]),
    msgTipsVisible() {
      return this.jurisdiction.indexOf('bdyCrm.viewBDCrm') != -1
    }
  },
  watch: {
    isView() {
      this.notView = false
    }
  },
  created() {
    this.getUpdateLog()
  },
  mounted() {
    if (document.documentElement.clientWidth < 800) {
      this.toggleSideBar()
    }
  },

  methods: {
    async getUpdateLog() {
      const res = await getYuqueDoc()
      if (res.data.length) {
        const _new = localStorage.getItem(
          `_UPDATE_LOGS_${this.user.userId}_VIEW_STATUS_${res.data[0].slug}`
        )
        if (_new) {
          this.notView = false
        } else {
          this.notView = true
        }
        this.logData = res.data[0]
      }
    },
    async goYuQueLogs() {
      localStorage.setItem(
        `_UPDATE_LOGS_${this.user.userId}_VIEW_STATUS_${this.logData.slug}`,
        true
      )
      this.notView = false
      window.open(
        'https://www.yuque.com/gh81kv/edllgb/' + this.logData.url,
        '_blank'
      )
      const status = this.isView // 重新赋值
      this.$store.dispatch('updateView/changeView', !status)
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      this.sendLogout()
    },
    toUser() {
      this.$router.push({ path: '/self/index' })
    },
    // 记录退出
    async sendLogout() {
      this.loading = true
      await sendLogout()
        .then((res) => {
        })
        .catch((err) => {
          console.log(err, 'err sendLogout')
        })
      this.$store.dispatch('login/logout')
      this.$router.push(`/login`)
    },

    // 切换账本
    switchSubarea(id) {
      const _params = {
        subareaId: id
      }
      return switchSubarea(_params)
        .then((res) => {
          // 切换账本需要清空缓存标签，不然由于路由属性的nocache为false会导致，切换账本后，进入工作台页面，不会重新请求接口
          return this.$store.dispatch('tagsView/delAllCachedViews')
        })
        .catch((err) => {
          console.log(err, 'err switchSubarea')
        })
    },

    async setName(name, id) {
      for (let i = 0; i < this.book.length; i++) {
        if (id === this.book[i].id) {
          this.$store.dispatch({
            type: 'login/setBookInfo',
            bookInfo: this.book[i]
          })
          sessionStorage.setItem('bookInfo', JSON.stringify(this.book[i]))
          break
        }
      }
      await this.switchSubarea(id)

      this.$router.push({
        path: '/redirect/index',
        query: {
          path: this.$route.path
        }
      })
    },

    manageBook() {
      this.$router.push({ path: '/account_book/index' })
    },

    // 赋值密码并且新窗口打开
    onCopy(e) {
      let _url = ''
      switch (e.text) {
        case 'gezq':
          _url =
            'https://www.yuque.com/books/share/0a7c75ec-11cf-4197-b7a2-86d91bef3694?#'
          break
        case 'tzii':
          _url =
            'https://www.yuque.com/books/share/3f318f40-8d20-4912-aa9b-6f4cf02609d0?#'
          break
        case 'xsam':
          _url = 'https://www.yuque.com/tingting-x3cqg/to7iyt'
          break
      }
      this.$message({
        type: 'success',
        message: '已经成功复制密码，即将跳转新页面',
        duration: 2000,
        onClose: () => {
          window.open('_blank').location.href = _url
        }
      })
    },
    // 赋值失败，给出提示信息
    onError(e) {
      // 不支持复制
      console.log('该浏览器不支持自动复制', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 60px;
  min-width: 1000px;
  overflow: hidden;
  position: relative;
  background: #fff;
  border-bottom: 1px solid #e0e3eb;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 58px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .active-menu {
    display: inline-block;
    vertical-align: middle;
    height: 60px;
    line-height: 60px;
    padding: 0 20px;
    font-size: 14px;
    font-weight: bold;
  }

  .right-menu {
    display: flex;
    float: right;
    height: 100%;
    line-height: 60px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 20px;

      .avatar-wrapper {
        position: relative;
        line-height: 60px;
        height: 60px;
        padding-right: 20px;

        .subareaName {
          color: #333333;
          font-weight: bold;
        }

        .no-subareaName {
          color: #cccccc;
        }

        .ducuments {
          color: #606266;

          >i {
            margin-right: 10px;
          }
        }

        // .user-avatar {
        //   display: inline-block;
        //   width: 32px;
        //   height: 32px;
        //   border-radius: 50%;
        //   overflow: hidden;
        //   vertical-align: middle;
        //   margin-right:10px;
        //   img {
        //     height: 100%;
        //     width: 100%;
        //   }
        // }

        >span {
          color: #6e86b1;
          font-size: 14px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: 0px;
          top: 50%;
          transform: translateY(-50%);
          font-size: 12px;
          vertical-align: middle;
        }
      }
    }

    .update-log-btn {
      float: left;
      margin-right: 20px;
      width: 78px;
      height: 37px;
      line-height: 37px;
      text-align: center;
      font-size: 12px;
      background: url("../../assets/imgs/update_log_btn.png");
      color: #fff;
      cursor: pointer;

      >span {
        display: inline-block;
        height: 16px;
        line-height: 16px;
        vertical-align: middle;
        border-radius: 8px;
        position: relative;
        transform: translateY(-2px);
        padding: 0 5px;
        background-color: #fff;
        color: #fd5c60;
        font-size: 11px;
        font-weight: 500;
      }
    }

    .data-log-btn {
      float: left;
      margin-right: 20px;
      width: 78px;
      height: 37px;
      line-height: 37px;
      text-align: center;
      font-size: 12px;
      background: url("../../assets/imgs/data_log_btn.png");
      color: #fff;
      cursor: pointer;
    }
  }
}
</style>
